import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_PRODUCT_API_URL;

export const getProducts = async ({
	productCategoryId,
	productTypeId,
	vendorId,
	makeId,
	modelId,
	variantId,
	yearId,
	pageNumber,
    limit,
}) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/product`, retry: true });

		const searchParams = new URLSearchParams();
		if (productCategoryId)
			searchParams.append("productCategoryId", encodeURIComponent(productCategoryId));
		if (productTypeId) searchParams.append("productTypeId", encodeURIComponent(productTypeId));
		if (vendorId) searchParams.append("vendorId", encodeURIComponent(vendorId));
		if (makeId) searchParams.append("makeId", encodeURIComponent(makeId));
		if (modelId) searchParams.append("modelId", encodeURIComponent(modelId));
		if (variantId) searchParams.append("variantId", encodeURIComponent(variantId));
		if (yearId) searchParams.append("yearId", yearId);
		if (pageNumber) searchParams.append("skip", pageNumber - 1);
		if (limit) searchParams.append("limit", limit);

		const requestUrl = `?${searchParams.toString()}`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

// Old printed QR codes/URLs point at string-based product listing filters
// (category/type/vendor/etc. names) from before the numeric-Id migration.
// This builds the URL for the BE's legacy redirect endpoint, which resolves
// those names and 301/302s to the canonical Id-based SPA URL. It must be
// hit via a full browser navigation (not fetched) so the browser follows
// the redirect itself.
export const getLegacyProductRedirectUrl = ({
	productCategory,
	productType,
	vendor,
	make,
	model,
	variant,
	year,
	pageNumber,
} = {}) => {
	const segments = [productCategory, productType]
		.filter((segment) => segment !== null && segment !== undefined && segment !== "")
		.map(encodeURIComponent)
		.join("/");

	const searchParams = new URLSearchParams();
	if (vendor) searchParams.append("vendor", vendor);
	if (make) searchParams.append("make", make);
	if (model) searchParams.append("model", model);
	if (variant) searchParams.append("variant", variant);
	if (year) searchParams.append("year", year);
	if (pageNumber) searchParams.append("pageNumber", pageNumber);

	const query = searchParams.toString();
	return `${url}/api/legacy/products${segments ? `/${segments}` : ""}${query ? `?${query}` : ""}`;
};

export const getPromotionProductsByHandle = async () => {
    //Needs to be created
    return {
        error: false,
        success: true,
        message: "",
        data: []
    };
};

export const getPrices = async ({
	productSkus,
	output
}) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/product`, retry: true });

		const requestUrl = `/prices`;

        const skus = Array.from(
            new Set((productSkus ?? []).map(s => (s ?? "").trim()).filter(Boolean))
        );

		const body = { skus, output };

		return await instance
			.post(requestUrl, body)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getStockInfo = async ({
                                    productSkus,
                                    output
                                }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/product`, retry: true });

        const requestUrl = `/stock-info`;

        const skus = Array.from(
            new Set((productSkus ?? []).map(s => (s ?? "").trim()).filter(Boolean))
        );

        const body = { skus, output };

        return await instance
            .post(requestUrl, body)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                }
                else if (error.request) {
                    console.error("Network Error:", error.request);
                }
                else {
                    console.error("Error:", error.message);
                }
            });
    }
    catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getProductBySku = async ({ sku }) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/product`, retry: true });

		return await instance
			.get(`/sku/${encodeURIComponent(sku)}`)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getProductData = async (productSkus) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/product`, retry: true });

		const requestUrl = `/products`;

        const body = { skus: productSkus };

		return await instance
			.post(requestUrl, body)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};


